<template>
    <div class="feedback-list">

        <div class=" flex a-c" style="margin-bottom: 20px;">
            <el-select class="search-box" v-model="paramsFilter.state" placeholder="请选择评论" size="large"
                @change="getTable">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <!-- <div class="input-container flex a-c" style="flex: 1;"> -->
            <el-input class="search-box" size="large" v-model="paramsFilter.relName" placeholder="请输入资源内容" clearable
                @clear="getTable" />
            <el-input class="search-box" size="large" v-model="paramsFilter.content" placeholder="请输入评论内容" clearable
                @clear="getTable" />
            <!-- <el-date-picker :cell-class-name="() => 'search-box'" class="search-box" v-model="paramsFilter.date" type="date" placeholder="请选择评论时间"
                size="large" /> -->

            <el-date-picker class="search-box" v-model="paramsFilter.date" type="daterange" range-separator="至"
                start-placeholder="评论开始时间" end-placeholder="评论结束时间" size="large" value-format="YYYY-MM-DD" />
            <!-- <el-select class="search-box" v-model="paramsFilter.type" placeholder="请选择审核人" size="large"
                @change="getTable">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select> -->
            <div class="button-container" @click="getTable">
                <i class="iconfont unify-sousuo"></i>
            </div>



            <!-- </div> -->
            <!-- 反馈 -->
            <div class="feedback-btn">
                <el-icon class="setting" @click="settingFlag = true">
                    <!-- <Setting /> -->
                </el-icon>
            </div>
        </div>

        <!--  -->
        <custom-table v-model:tableColumns="tableData" :data="dataList" max-height="calc(100vh - 330px)"
            v-loading="loading">
            <template #dbEdit="{ row }">
                <span class="ep-click" @click="goDbDetail(row)">
                    {{ row.dbName }}
                </span>
            </template>
            <template #edit="{ row }">
                <div class="table-edit-public">
                    <span class="ep-click btn edit" @click="handleState(row)">{{ row.state == 0 ? '审核' : '详情' }}</span>
                </div>
            </template>
        </custom-table>

        <!-- 分页 -->
        <div>
            <customPagination v-show="total > 0" :total="total" v-model:page="paramsFilter.currentPage"
                v-model:limit="paramsFilter.limit" @pagination="getFindList()" />
        </div>

        <!-- -->
        <custom-dialog v-model="detailObj.detailFlag" :title="detailObj.commentDetail.state == 0 ? '审核评论' : '评论详情'"
            v-loading="dialogLoading">
            <div class="commentDetail-box">
                <div class="flex  row" v-if="detailObj.commentDetail.relName">
                    <div class="label">资源名称:</div>
                    <div class="text">{{ detailObj.commentDetail.relName }}</div>
                </div>
                <div class="flex  row" v-if="detailObj.commentDetail.userName">
                    <div class="label">评论人:</div>
                    <div class="text">{{ detailObj.commentDetail.userName }}</div>
                </div>
                <div class="flex  row" v-if="detailObj.commentDetail.createdTimeStr">
                    <div class="label">评论时间:</div>
                    <div class="text">{{ detailObj.commentDetail.createdTimeStr }}</div>
                </div>
                <div class="flex  row" v-if="detailObj.commentDetail.content">
                    <div class="label">评论内容:</div>
                    <div class="text">{{ detailObj.commentDetail.content }}</div>
                </div>

                <div class="flex  row" v-if="detailObj.commentDetail.auditUserName">
                    <div class="label">审核人:</div>
                    <div class="text">{{ detailObj.commentDetail.auditUserName }}</div>
                </div>

                <template v-if='detailObj.commentDetail.state == 0'>
                    <div>
                        <div class="flex  row">
                            <div class="label">审核状态:</div>
                            <div class="text">
                                <el-radio-group v-model="detailObj.params.state">
                                    <el-radio :value="1" size="large">审核通过</el-radio>
                                    <el-radio :value="2" size="large">审核失败</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="flex  row">
                            <div class="label">审核原因:</div>
                            <div class="text">
                                <el-input v-model="detailObj.params.reason"  style="width: 400px"
                                :rows="4"
                                type="textarea" placeholder="请输入审核原因" size="large" maxlength="200"/>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="flex  row" v-if="detailObj.commentDetail.stateStr">
                        <div class="label">审核状态:</div>
                        <div class="text">{{ detailObj.commentDetail.stateStr }}
                        </div>
                    </div>

                    <div class="flex  row" v-if="detailObj.commentDetail.reason">
                        <div class="label">审核原因:</div>
                        <div class="text">{{ detailObj.commentDetail.reason }}
                        </div>
                    </div>
                </template>


            </div>

            <template #footer v-if="detailObj.commentDetail.state == 0">
                <div class="dialog-footer">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click='checkSub'>
                        审 核
                    </el-button>
                </div>
            </template>
        </custom-dialog>
    </div>
</template>
<script setup>
import { MessageBox } from "@/js/utils/commonJs";
import { ref, reactive, computed } from "vue";
import { findManageCommonCommentPage, findOneCommonCommentById, auditComment } from "@/js/network/main";
import router from "@/router";
const loading = ref(false);
const total = ref(0);
//列表数据
let dataList = ref([]);

const detailObj = reactive({
    detailFlag: false,
    commentDetail: {},
    dialogLoading: false,
    params: {
        id: "", // 评论id
        state: 1, // 审核状态  1 通过 2 不通过
        reason: "", // 审核原因
    }
})

const settingFlag = ref(false)

const paramsFilter = reactive({
    currentPage: 1,
    limit: 10,
    state: 0,
    content: "",
    // 资源名称
    relName: "",
    date: ""
});


const perviewIndex = ref(0)

const tableData = computed(() => {
    return [
        {
            label: "资源名称",
            minWidth: "120px",
            align: "center",
            prop: "relName",
        },
        {
            label: "评论内容",
            minWidth: "120px",
            align: "center",
            prop: "content",
        },
        {
            label: "评论人",
            width: "120px",
            align: "center",
            prop: "userName",
            showOverflowTooltip: false,
        },
        {
            label: "评论时间",
            width: "160px",
            align: "center",
            prop: "createdTimeStr",
            showOverflowTooltip: false,
        },
        {
            label: "状态",
            width: "100px",
            align: "center",
            prop: "stateStr",
            showOverflowTooltip: false,
        },
        // {
        //     label: "审核人",
        //     width: "120px",
        //     align: "center",
        //     prop: "auditUserName",
        //     showOverflowTooltip: false,
        // },
        {
            label: "操作",
            width: "140px",
            align: "center",
            template: 'edit',
            showOverflowTooltip: false,
        },

    ]
})

const goDbDetail = (val) => {
    if (val) {
        router.push(`/dbConfig/detailSetting?id=${val.unifyVdatabaseDetailsId}&dId=${val.did}`)
    }
}

// 1 平台反馈  2 数据库反馈
const typeList = ref([
    {
        id: '',
        name: "全部"
    },
    {
        id: 0,
        name: "待审核"
    },
    {
        id: 1,
        name: "审核通过"
    },
    {
        id: 2,
        name: "审核不通过"
    }
])



const getTable = () => {
    paramsFilter.currentPage = 1;
    getFindList();
};




// 请求数据
const getFindList = () => {
    loading.value = true;

    let params = {
        currentPage: paramsFilter.currentPage,
        limit: paramsFilter.limit,
        state: paramsFilter.state,
        content: paramsFilter.content,
        relName: paramsFilter.relName,
    }
    if (paramsFilter.date) {
        params.startTime = paramsFilter.date[0]
        params.endTime = paramsFilter.date[1]
    }


    findManageCommonCommentPage(params).then((res) => {
        loading.value = false;
        if (!res.success) {
            MessageBox.error(res.msg);
            return;
        }

        dataList.value = res.data;
        total.value = Number(res.count);
    })
        .catch((error) => {
            console.log(error, "catchError");
        });
}

const handleState = (row) => {
    detailObj.commentDetail = {};
    detailObj.detailFlag = true;
    detailObj.dialogLoading = true;
    findOneCommonCommentById({ id: row.id, state: paramsFilter.state }).then(res => {
        detailObj.dialogLoading = false;
        if (!res.success) {
            MessageBox.error(res.msg);
            return;
        }
        detailObj.commentDetail = res.data;
    }).catch((error) => {
        detailObj.dialogLoading = false;
        console.log(error, "catchError");
    });
}


const checkSub = () => {
    detailObj.dialogLoading = true;
    if (detailObj.params.state == 2 && !detailObj.params.reason) {
        MessageBox.warning("请输入审核原因");
        detailObj.dialogLoading = false;
        return;
    }
    auditComment({...detailObj.params , id:detailObj.commentDetail.id}).then(res => {
        detailObj.dialogLoading = false;
        if (!res.success) {
            MessageBox.error(res.msg);
            return;
        }
        cancel();
        // 刷新数据
        getFindList();
    }).catch((error) => {
        detailObj.dialogLoading = false;
        console.log(error, "catchError");
    });
}

const cancel = () => {
    detailObj.detailFlag = false;
    resetCheck()
}

const resetCheck = () => {
    detailObj.params = {
        id: "", // 评论id
        state: 1, // 审核状态  1 通过 2 不通过
        reason: "", // 审核原因
    } 
}


getFindList()

</script>
<style lang="scss" scoped>
.feedback-btn {
    padding: 10px 20px 0 20px;

    >.setting {
        color: $primary;
        font-size: 24px;
        cursor: pointer;
    }
}

.search-box {
    width: 0;
    flex: 1;
    margin-right: 10px;
}

:deep(.search-box) {
    width: 0;
    flex: 1;
    margin-right: 10px;
}

.feedback-list {
    padding: 20px 0;
    background-color: #ffffff;
    border-radius: 20px 0 0 0;

    .input-container {
        height: 38px;
        // margin-bottom: 20px;
        // border: 1px solid #ccc;
        border-radius: 4px;

        .iconfont {
            font-size: 20px;
            font-weight: 600;
        }


    }

    // .input-container:focus-within {
    //     border: 1px solid #409eff;
    // }

    .button-container {
        height: 40px;
        width: 64px;
        flex-shrink: 0;
        text-align: center;
        line-height: 40px;
        color: #ffffff;
        font-size: 16px;
        cursor: pointer;
        user-select: none;
        background: #2054d6;
        border-radius: 2px;
    }

    // :deep(.el-input__wrapper) {
    //     box-shadow: none !important;
    //     background: transparent !important;

    //     &.is-focused {
    //         box-shadow: none !important;
    //     }

    //     &.is-hovering {
    //         box-shadow: none !important;
    //     }
    // }
}


.commentDetail-box {
    padding: 20px;
    min-height: 280px;

    max-height: 400px;
    overflow-y: auto;
    // overflow-x: hidden;

    .row {
        margin-bottom: 10px;

        .label {
            width: 80px;
            color: #9a9a9a;
            flex-shrink: 0;
        }
    }
}
</style>